var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAccountSummary, useRewardsBalance, useRewardsCertificate, } from "../const/syfApiQueries";
import useRewardsExperienceQuery from "../services/rewardsExperience/rewardsExperienceQuery";
import { rewardIds } from "../typings/rewardsTypes";
import { useRewardsConfigContext } from "../context/rewardsConfig";
import { getSelectedAccountId } from "../helpers/sessionAccountId";
var useRewards = function () {
    var _a, _b, _c;
    var config = useRewardsConfigContext().config;
    var selectedAccountId = getSelectedAccountId();
    var _d = useAccountSummary(selectedAccountId, config), accountSummary = _d.data, isLoadingAccountSummary = _d.isLoading, isAccountSummaryError = _d.isError;
    var clientId = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.clientId) !== null && _a !== void 0 ? _a : "";
    var cardType = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.type;
    var _e = useRewardsExperienceQuery(config), rewardsExperience = _e.data, isLoadingRewardsExperience = _e.isLoading, isRewardsExperienceError = _e.isError;
    var hasRewardsBalance = Boolean((_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b[cardType].rewardsBalance);
    var hasCertificateHistory = Boolean((_c = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _c === void 0 ? void 0 : _c[cardType].certificateHistory);
    var _f = useRewardsBalance({
        accountId: selectedAccountId,
        config: __assign(__assign({}, config), { clientId: clientId }),
        hasRewardsBalance: hasRewardsBalance,
    }), rewardsBalance = _f.data, isLoadingRewardsBalance = _f.isLoading, isErrorRewardsBalance = _f.isError, isRewardsBalanceFetching = _f.isFetching;
    var _g = useRewardsCertificate({
        config: __assign(__assign({}, config), { clientId: clientId }),
        accountId: selectedAccountId,
        hasCertificateHistory: hasCertificateHistory,
        certificateRequestType: "ALL",
    }), allRewardsCertificate = _g.data, isLoadingAllRewardsCertificate = _g.isLoading, isAllRewardsCertificateError = _g.isError, isCertificatesFetching = _g.isFetching;
    var isLoading = isLoadingAccountSummary ||
        isLoadingRewardsExperience ||
        (isLoadingRewardsBalance && isRewardsBalanceFetching) ||
        (isLoadingAllRewardsCertificate && isCertificatesFetching);
    var isError = isAccountSummaryError ||
        isRewardsExperienceError ||
        isErrorRewardsBalance ||
        isAllRewardsCertificateError;
    var certificates = allRewardsCertificate;
    var rewardDetails = {};
    rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails.forEach(function (reward) {
        var rewardId = reward.Id;
        if (rewardIds.includes(rewardId)) {
            rewardDetails[rewardId] = reward;
        }
    });
    return {
        accountSummary: accountSummary,
        allRewardsCertificate: allRewardsCertificate,
        cardType: cardType,
        certificates: certificates,
        clientId: clientId,
        hasCertificateHistory: hasCertificateHistory,
        isError: isError,
        isLoading: isLoading,
        rewardsBalance: rewardsBalance,
        rewardDetails: rewardDetails,
        rewardsExperience: rewardsExperience,
    };
};
export default useRewards;
